/**
 * Safely converts a value coming from the API to a number.
 * `/api/load` views return numeric columns as strings, so any value that is
 * passed to `AmountAndCurrency` or used in arithmetic has to be coerced first.
 */
export const toNumber = (value: unknown): number => {
	if (value === null || value === undefined || value === '') return 0;
	const numberValue = Number(value);
	return Number.isFinite(numberValue) ? numberValue : 0;
};
